import React from "react";
import { X, MapPin, Calendar, ExternalLink } from "lucide-react";
import { imgSrc, useContent } from "../lib/content";

const fmt = (iso) => {
  const s = new Date(iso).toLocaleString("it-IT", { weekday: "long", day: "2-digit", month: "long", hour: "2-digit", minute: "2-digit" });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

function InfoRow({ icon: Icon, children }) {
  return <div className="flex items-center gap-2 font-mono text-xs text-neutral-300 tracking-wider"><Icon className="w-3 h-3 text-neon"/>{children}</div>;
}

export default function EventDetailModal({ event: ev, onClose, onList }) {
  const { c } = useContent();
  return (
    <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-neutral-950 border border-neutral-800 w-full max-w-4xl max-h-[92vh] overflow-y-auto grid md:grid-cols-2 relative"
        onClick={e=>e.stopPropagation()} data-testid="event-detail-modal">
        <button className="absolute top-3 right-3 z-10 bg-black/70 p-1 text-neutral-300 hover:text-white" onClick={onClose} aria-label="Chiudi" data-testid="event-detail-close"><X/></button>
        <img src={imgSrc(ev.poster_url)} alt={ev.title} className="w-full h-full max-h-[92vh] object-contain bg-black" data-testid="event-detail-poster"/>
        <div className="p-6 md:p-8 flex flex-col gap-5">
          <h2 className="font-display text-3xl lg:text-4xl leading-none" data-testid="event-detail-title">{ev.title}</h2>
          <div className="space-y-2">
            <InfoRow icon={Calendar}><span>{fmt(ev.date)}</span></InfoRow>
            <InfoRow icon={MapPin}>{ev.venue} · {ev.city}</InfoRow>
          </div>
          {ev.lineup?.length > 0 && (
            <div>
              <div className="label-mono mb-2">LINE-UP</div>
              <div className="flex flex-wrap gap-1">
                {ev.lineup.map(dj => <span key={dj} className="font-mono text-[10px] tracking-widest border border-neutral-700 px-2 py-1">{dj.toUpperCase()}</span>)}
              </div>
            </div>
          )}
          {ev.description && <p className="text-sm text-neutral-300 whitespace-pre-line" data-testid="event-detail-description">{ev.description}</p>}
          <div>
            <div className="label-mono text-[9px]">PREZZO DA</div>
            <div className="font-display text-3xl text-neon" data-testid="event-detail-price">€{ev.price_from}</div>
          </div>
          {ev.list_url && (
            <a href={ev.list_url} target="_blank" rel="noopener noreferrer" onClick={(e)=>{ e.preventDefault(); onList(ev); }}
              className="font-mono text-xs text-neutral-400 break-all hover:text-neon flex items-center gap-1" data-testid="event-detail-list-url">
              <ExternalLink className="w-3 h-3 shrink-0"/>{ev.list_url}
            </a>
          )}
          <button onClick={()=>onList(ev)} className="btn-primary mt-auto" data-testid="event-detail-list-btn">{c.home_list_button}</button>
        </div>
      </div>
    </div>
  );
}
